module.exports = __webpack_public_path__ + "static/img/ganmao.c244ef2a.png";